/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Groupsmembers1Inputs */

const en_groupsmembers1 = /** @type {(inputs: Groupsmembers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Members`)
};

const de_groupsmembers1 = /** @type {(inputs: Groupsmembers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitglieder`)
};

/**
* | output |
* | --- |
* | "Members" |
*
* @param {Groupsmembers1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const groupsmembers1 = /** @type {((inputs?: Groupsmembers1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Groupsmembers1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_groupsmembers1(inputs)
	return de_groupsmembers1(inputs)
});
export { groupsmembers1 as "groupsMembers" }